import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SuccessPopupModel } from '../../../../models/ui.model';

@Component({
    selector: 'app-successful-with-icon-popup',
    templateUrl: './successful-with-icon-popup.component.html',
    styleUrl: './successful-with-icon-popup.component.scss',
})
export class SuccessfulWithIconPopupComponent {
    constructor(
        @Inject(MAT_DIALOG_DATA) public dialogModel: SuccessPopupModel,
        public dialogRef: MatDialogRef<SuccessfulWithIconPopupComponent>,
    ) {}

    close(): void {
        this.dialogRef.close();
    }
}
